import { Fragment, memo, ReactElement } from 'react';
import loadable from '@loadable/component';

import { MARKET_NEWS_ANCHOR } from '@/constants/anchors';

import PageAnchor from '@/components/PageAnchor';
import { FeedCardSkeleton } from '@/components/FeedCard';

import ScrollTracking from '../ScrollTracking';

import useUser from '@/hooks/useUser';
import useReduxStateMarket, {
  MarketPageType,
} from '../../hooks/useReduxStateMarkets';
import useIndustryGetter from '../../hooks/useIndustryGetter';
import useMarketFeed from '../../hooks/useMarketFeed';

import MarketFeedCard from './MarketFeedCard';

import {
  Container,
  SidebarContainer,
  Title,
  Wrapper,
  FeedCardContainer,
} from './styled';

const MemoMarketFeedCard = memo(MarketFeedCard);
const BrazeContentCard = loadable(() => import('@components/BrazeContentCard'));

interface Props {
  children?: ReactElement;
}

const CompanyFeeds = ({ children }: Props) => {
  const { data: user } = useUser();
  const { market, marketPageType } = useReduxStateMarket();
  const [industry, enabled] = useIndustryGetter();
  const { data, isFetching } = useMarketFeed(
    market,
    industry.id,
    marketPageType === MarketPageType.MARKET ? true : enabled
  );

  return (
    <Container>
      <PageAnchor id={MARKET_NEWS_ANCHOR} />
      <Wrapper>
        {children}
        <Title>Latest News</Title>
        <SidebarContainer>
          {user.loggedIn && (
            <BrazeContentCard feedType="market-page" anchorTarget="_blank" />
          )}
          {isFetching ? (
            <FeedCardContainer>
              <FeedCardSkeleton />
            </FeedCardContainer>
          ) : (
            data.map((item, index) => (
              <Fragment key={index}>
                {index === data.length - 1 && (
                  <ScrollTracking subject="company-feeds-bottom" />
                )}
                <MemoMarketFeedCard company={item} />
              </Fragment>
            ))
          )}
        </SidebarContainer>
      </Wrapper>
    </Container>
  );
};

export default CompanyFeeds;
